import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone } from "lucide-react";
import { BRAND } from "@/lib/brand";
import { Wordmark, BrandIcon } from "@/components/Brand";

const footerLinks = [
  {
    title: "מוצר",
    links: [
      { label: "תכונות", href: "/features/" },
      { label: "מחירים", href: "/pricing/" },
      { label: "אודות", href: "/about/" },
    ],
  },
  {
    title: "תמיכה",
    links: [
      { label: "צור קשר", href: "/contact/" },
      { label: "מדריכים", href: "/articles/" },
    ],
  },
  {
    title: "משפטי",
    links: [
      { label: "תנאי שימוש", href: "/terms/" },
      { label: "מדיניות פרטיות", href: "/privacy/" },
      { label: "אבטחת מידע", href: "/security/" },
      { label: "הצהרת נגישות", href: "/accessibility/" },
    ],
  },
];

export default function PublicFooter() {
  return (
    <footer className="bg-zinc-900 dark:bg-zinc-950 border-t border-white/5 text-white/80">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <BrandIcon size={36} className="rounded-xl" />
              <Wordmark className="text-lg text-white" />
            </Link>
            <p className="text-sm text-white font-medium mb-1">{BRAND.slogan}</p>
            <p className="text-sm text-white/60 leading-relaxed mb-4">
              מערכת הנהלת חשבונות חכמה לעסקים ישראליים. פשוט, מקצועי, ותואם לרשות המסים.
            </p>
            <div className="space-y-2 text-sm text-white/50">
              <div className="flex items-center gap-2">
                <Mail className="w-4 h-4" />
                <span dir="ltr">{BRAND.email}</span>
              </div>
              {BRAND.phone && (
                <div className="flex items-center gap-2">
                  <Phone className="w-4 h-4" />
                  <span dir="ltr">{BRAND.phone}</span>
                </div>
              )}
            </div>
          </div>

          {/* Links */}
          {footerLinks.map((group) => (
            <div key={group.title}>
              <p className="font-heading font-bold text-white mb-4 text-sm">
                {group.title}
              </p>
              <ul className="space-y-2">
                {group.links.map((link) => (
                  <li key={link.href}>
                    <Link
                      to={link.href}
                      className="text-sm text-white/70 hover:text-white transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-white/10 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-white/60">
            © {new Date().getFullYear()} {BRAND.name}. כל הזכויות שמורות.
          </p>
          <p className="text-sm text-white/60">
            תוכנה ישראלית 🇮🇱 מותאמת לרשות המסים
          </p>
        </div>
      </div>
    </footer>
  );
}